import { createReducer, on } from '@ngrx/store';
import {
  getSampleData,
  setSampleData,
  saveSampleData,
  deleteSampleData,
  triggerSampleData
} from '../actions/sampleData.actions';

export interface SampleDataSate {
  data: any;
}

export const initialState: SampleDataSate = {
  data: {}
};

export const sampleDataReducer = createReducer(
  initialState,
  on(getSampleData, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(triggerSampleData, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setSampleData, (state, { sampleDataTable }) => ({
    ...state,
    ...{ sampleDataTable }
  })),
  on(saveSampleData, (state, { sampleData }) => ({
    ...state,
    ...sampleData
  })),
  on(deleteSampleData, (state, { sampleDataIds }) => {
    return {
      ...state,
      sampleDataIds
    };
  })
);
